<template>
  <div>
    <!-- 信息填充：登记/编辑辅料 -->
    <el-dialog :title="isEdit ? '编辑辅料' : '登记辅料'" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="760px" center @closed="resetForm">
      <el-form ref="formData" :model="formData" :rules="rules" label-width="100px" class="material-form">
        <!-- 客户信息 -->
        <div class="section-title">客户信息</div>
        <div class="border"></div>
        <el-form-item label="客户ID" prop="user_id">
          <el-input v-model.trim="formData.user_id" placeholder="请输入客户ID" @blur="getClientName" />

        </el-form-item>
        <el-form-item label="客户名称">
          <el-input v-model="clientName" disabled placeholder="这里是客户名称" />
        </el-form-item>

        <!-- 基本信息 -->
        <div class="section-title">基本信息</div>
        <div class="border"></div>
        <el-form-item label="辅料译文名" prop="name_trans">
          <el-input v-model.trim="formData.name_trans" placeholder="请输入辅料译文名" />
        </el-form-item>
        <el-form-item label="类型" prop="type_id">
          <el-select v-model="formData.type_id" placeholder="请选择辅料类型" filterable clearable>
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="消耗" prop="consume">
          <el-input v-model.trim="formData.consume" placeholder="请输入默认消耗" class="consume-input"
            @input="handleConsumeInput">
            <template slot="append">点/套</template>
          </el-input>
        </el-form-item>

        <!-- 详细信息 -->
        <div class="section-title">详细信息</div>
        <div class="border"></div>
        <el-form-item label="注意事项">
          <el-input v-model="formData.notice" type="textarea" :rows="5" placeholder="请输入注意事项" />
        </el-form-item>

        <!-- 文件添加 -->
        <div class="section-title">文件添加</div>
        <div class="border"></div>
        <el-form-item label="主图" prop="main_image">
          <div class="upload-list">
            <div class="upload-item" v-if="formData.main_image">
              <el-image :src="formData.main_image" fit="cover" class="upload-img"
                :preview-src-list="[formData.main_image]" />
              <i class="el-icon-error delete-icon" @click="formData.main_image = ''"></i>
            </div>
            <el-upload v-else action="#" :http-request="uploadMainImage" :before-upload="beforeImageUpload"
              :show-file-list="false">
              <div class="upload-card">
                <i class="el-icon-circle-plus"></i>
                <p>上传图片</p>
              </div>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item label="图片">
          <div class="upload-list">
            <div class="upload-item" v-for="(item, index) in formData.images" :key="item">
              <el-image :src="item" fit="cover" class="upload-img" :preview-src-list="formData.images" />
              <i class="el-icon-error delete-icon" @click="removeImage(index)"></i>
            </div>
            <el-upload v-if="formData.images.length < maxImageCount" action="#" :http-request="uploadImages"
              :before-upload="beforeDetailImageUpload" :show-file-list="false">
              <div class="upload-card">
                <i class="el-icon-circle-plus"></i>
                <p>上传图片</p>
              </div>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item label="文件">
          <div class="upload-list">
            <div class="file-item" v-for="(item, index) in formData.files" :key="item">
              <i class="el-icon-document"></i>
              <span :title="getFileName(item)">{{ getFileName(item) }}</span>
              <i class="el-icon-error delete-icon" @click="removeFile(index)"></i>
            </div>
            <el-upload v-if="formData.files.length < maxFileCount" action="#" :http-request="uploadFiles"
              :before-upload="beforeFileUpload" :show-file-list="false">
              <div class="upload-card">
                <i class="el-icon-circle-plus"></i>
                <p>上传文件</p>
              </div>
            </el-upload>
          </div>
          <div class="file-tip">ファイルが多い場合は、zipに圧縮してアップロードしてください。</div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saveLoading" @click="save">{{ isEdit ? '保存' : '创建' }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MaterialForm',
  props: {
    typeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      saveLoading: false,
      isEdit: false,
      clientName: '',
      maxImageCount: 8,
      maxFileCount: 3,
      formData: this.getDefaultForm(),
      rules: {
        user_id: [{ required: true, message: '请输入客户ID', trigger: 'blur' }],
        name_trans: [{ required: true, message: '请输入辅料译文名', trigger: 'blur' }],
        type_id: [{ required: true, message: '请选择辅料类型', trigger: 'change' }],
        consume: [
          { required: true, message: '请输入默认消耗', trigger: 'blur' },
          { validator: this.validateConsume, trigger: 'blur' }
        ],
        main_image: [{ required: true, message: '请上传主图', trigger: 'change' }],
        notice: [{ required: true, message: '请输入注意事项', trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 消耗只能输入大于 0 的正整数
    handleConsumeInput(value) {
      this.formData.consume = String(value || '').replace(/\D/g, '').replace(/^0+/, '')
    },
    // 校验默认消耗是否为大于 0 的正整数
    validateConsume(rule, value, callback) {
      if (/^[1-9]\d*$/.test(String(value || ''))) {
        callback()
        return
      }
      callback(new Error('默认消耗只能输入大于0的正整数'))
    },
    // 默认表单字段，字段名和接口参数保持一致
    getDefaultForm() {
      return {
        id: '',
        user_id: '',
        name_trans: '',
        type_id: '',
        consume: '1',
        main_image: '',
        images: [],
        files: [],
        notice: ''
      }
    },
    // 打开新增弹框，订单入口可传入已有的客户、商品信息。
    openAdd(data = {}, clientName = '') {
      this.isEdit = false
      this.formData = { ...this.getDefaultForm(), ...data }
      this.clientName = clientName
      if (this.formData.user_id && !this.clientName) this.getClientName()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formData && this.$refs.formData.clearValidate()
      })
    },
    // 打开编辑弹框，先拉取详情再回填
    openEdit(item) {
      this.isEdit = true
      this.dialogVisible = true
      this.formData = this.getDefaultForm()
      this.$api.warehouseApi.materialDetail({ id: item.id }).then(res => {
        const data = res.data || {}
        this.setFormData(data)
      })
    },
    // 将详情数据回填到表单，兼容接口可能返回的不同图片字段
    setFormData(data) {
      this.formData = {
        id: data.id || '',
        user_id: data.user_id || '',
        name_trans: data.name_trans || '',
        type_id: data.type_id || '',
        consume: data.consume != null ? data.consume : '0',
        main_image: data.main_image || '',
        images: this.normalizeFileList(data.images || data.image_list || []),
        files: this.normalizeFileList(data.files || data.file_list || []),
        notice: data.notice || ''
      }
      this.clientName = data.user ? data.user.realname : ''
    },
    // 图片/文件列表统一转成 url 数组
    normalizeFileList(list) {
      if (!Array.isArray(list)) return []
      return list.map(item => {
        if (typeof item === 'string') return item
        return item.url || item.path || item.image || item.file || item.file_url || item.main_image || ''
      }).filter(Boolean)
    },
    // 根据客户ID查询客户名称
    getClientName() {
      if (!this.formData.user_id) {
        this.clientName = ''
        return
      }
      this.clientName = ''
      this.$api.clienteleApi.clientList({ id: this.formData.user_id }).then(res => {
        const list = (res.data && res.data.data) || []
        if (!list.length) {
          this.$message.error('客户ID不存在')
          return
        }
        this.clientName = list[0].realname || ''
      })
    },
    // 上传主图
    async uploadMainImage(file) {
      const data = await this.createClient(file)
      this.formData.main_image = data.data
      this.$refs.formData && this.$refs.formData.validateField('main_image')
    },
    // 上传详情图
    async uploadImages(file) {
      if (this.formData.images.length >= this.maxImageCount) {
        this.$message.warning(`图片最多上传${this.maxImageCount}张`)
        return
      }
      const data = await this.createClient(file)
      if (this.formData.images.length >= this.maxImageCount) return
      this.formData.images.push(data.data)
    },
    // 上传文件
    async uploadFiles(file) {
      if (this.formData.files.length >= this.maxFileCount) {
        this.$message.warning(`文件最多上传${this.maxFileCount}个`)
        return
      }
      const data = await this.createClient(file)
      if (this.formData.files.length >= this.maxFileCount) return
      this.formData.files.push(data.data)
    },
    // 图片上传前校验
    beforeImageUpload(file) {
      const isImage = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/webp'].indexOf(file.type) !== -1
      if (!isImage) {
        this.$message.error('请上传图片')
      }
      return isImage
    },
    // 详情图上传前校验类型和数量
    beforeDetailImageUpload(file) {
      if (this.formData.images.length >= this.maxImageCount) {
        this.$message.warning(`图片最多上传${this.maxImageCount}张`)
        return false
      }
      return this.beforeImageUpload(file)
    },
    // 文件上传前校验数量
    beforeFileUpload() {
      if (this.formData.files.length >= this.maxFileCount) {
        this.$message.warning(`文件最多上传${this.maxFileCount}个`)
        return false
      }
      return true
    },
    // 删除详情图
    removeImage(index) {
      this.formData.images.splice(index, 1)
    },
    // 删除文件
    removeFile(index) {
      this.formData.files.splice(index, 1)
    },
    // 从 OSS 地址中截取文件名，并将编码后的中文文件名转回中文
    getFileName(url) {
      const fileName = ((url || '').split('/').pop() || url).split('?')[0]
      try {
        return decodeURIComponent(fileName)
      } catch (error) {
        return fileName
      }
    },
    // 保存辅料
    save() {
      if (this.saveLoading) return
      this.saveLoading = true
      this.$refs.formData.validate(valid => {
        if (!valid) {
          this.saveLoading = false
          return
        }
        const datas = this.getSubmitData()
        const api = this.isEdit ? this.$api.warehouseApi.materialUpdate : this.$api.warehouseApi.materialStore
        api(datas).then(res => {
          this.$message.success(res.msg)
          this.dialogVisible = false
          this.$emit('saved')
        }).finally(() => {
          this.saveLoading = false
        })
      })
    },
    // 组装提交参数，数组会由 qs 转为 images[0]、files[0]
    getSubmitData() {
      const datas = {
        user_id: this.formData.user_id,
        name: this.formData.name_trans,
        name_trans: this.formData.name_trans,
        type_id: this.formData.type_id,
        consume: this.formData.consume,
        main_image: this.formData.main_image,
        images: this.formData.images,
        files: this.formData.files,
        notice: this.formData.notice
      }
      if (this.isEdit) datas.id = this.formData.id
      return datas
    },
    // 关闭后清理表单状态
    resetForm() {
      this.formData = this.getDefaultForm()
      this.clientName = ''
      this.saveLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.material-form {
  padding: 0 16px;

  /deep/.el-form-item__label {
    position: relative;
  }

  /deep/.el-input,
  /deep/.el-select,
  /deep/.el-textarea {
    width: 360px;
  }

  /deep/.el-textarea__inner {
    width: 360px;
  }
}

.section-title {
  margin: 22px 0 16px;
  padding-left: 8px;
  line-height: 16px;
  font-weight: 600;
  border-left: 4px solid #b4272d;
}

.border {
  height: 1px;
  width: 100%;
  background-color: #ccc;
  margin-bottom: 20px;
}

.field-error {
  line-height: 18px;
  color: #b4272d;
  font-size: 12px;
}

.consume-input {
  width: 180px !important;
}

.upload-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.upload-card,
.upload-item,
.file-item {
  position: relative;
  width: 110px;
  height: 110px;
  border: 1px dashed #dcdfe6;
  box-sizing: border-box;
  text-align: center;
  color: #999;
  background: #fff;
}

.upload-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  i {
    color: #15ad3c;
    font-size: 20px;
  }

  p {
    margin: 8px 0 0;
    line-height: 16px;
  }
}

.upload-img {
  width: 100%;
  height: 100%;
}

.file-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px;

  .el-icon-document {
    color: #a85c37;
    font-size: 42px;
  }

  span {
    display: -webkit-box;
    width: 100%;
    height: 32px;
    margin-top: 8px;
    line-height: 16px;
    overflow: hidden;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}

.delete-icon {
  position: absolute;
  top: -8px;
  right: -8px;
  color: #b4272d;
  font-size: 18px;
  cursor: pointer;
  background: #fff;
  border-radius: 50%;
}

.file-tip {
  margin-top: 8px;
  color: #b4272d;
  font-size: 12px;
}
</style>
